import React, { Component } from 'react';
import FileInput from 'react-fine-uploader/file-input';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import Gallery from 'react-fine-uploader'
import { connect } from 'react-redux';
import Thumbnail from 'react-fine-uploader/thumbnail';
import Status from 'react-fine-uploader/status';
import { Row, Col, ProgressBar, Alert, Image, Label } from 'react-bootstrap';
import update from 'immutability-helper';

const uploadStatus = {
	success: 1,
	error: 2
};

class FileListener extends Component {

	constructor(props) {
		super(props);
		this.createState();
		this.onStatusChange = this.onStatusChange.bind(this);
		this.onProgress = this.onProgress.bind(this);
		this.onComplete = this.onComplete.bind(this);
		this.onError = this.onError.bind(this);
	}

	createState() {
		const initialData = this.props.initialData;
		// Called only from the constructor, so this is initialisation rather than a mutation
		// of mounted state - ESLint cannot see the call site.
		// eslint-disable-next-line react/no-direct-mutation-state
		this.state = {
			didSetInitialData: !!initialData,
			submittedFile: {
				filename: initialData ? initialData.filename : 'undefined',
				url: initialData ? initialData.url : 'undefined',
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		const initialData = nextProps.initialData;
		if (!this.state.didSetInitialData && initialData) {
			this.setState(update(this.state, {
				didSetInitialData: { $set: true },
				submittedFile: { filename: { $set: initialData.filename }, url: { $set: initialData.url } }
			}));
		}
	}

	componentDidMount() {
		this.props.uploader.on('statusChange', this.onStatusChange);
		this.props.uploader.on('progress', this.onProgress);
		this.props.uploader.on('complete', this.onComplete);
		this.props.uploader.on('error', this.onError);
	}

	componentWillUnmount() {
		this.props.uploader.off('statusChange', this.onStatusChange);
		this.props.uploader.off('progress', this.onProgress);
		this.props.uploader.off('complete', this.onComplete);
		this.props.uploader.off('error', this.onError);
	}

	onProgress(id, name, uploadedBytes, totalBytes) {
		this.setState(update(this.state, {
			submittedFile: { $merge: { now: uploadedBytes, max: totalBytes } }
		}));
	}

	onComplete(id, name, response) {
		const { success, message, url, files, fileId } = response;
		if (!success) {
			this.setState(update(this.state, {
				submittedFile: { $merge: { fromServer: true, status: uploadStatus.error, error: response.message } }
			}));
			return;
		}

		const onChange = this.props.input.onChange;
		if (onChange) {
			onChange(fileId);
		}

		this.setState(update(this.state, {
			submittedFile: { $merge: { url, filename: files[0].name } }
		}));
	}

	onError(id, name, errorReason) {
		this.setState(update(this.state, {
			submittedFile: { $merge: { fromServer: true, status: uploadStatus.error, error: errorReason } }
		}));
	}

	onStatusChange(id, oldStatus, status) {
		const statusEnum = this.props.uploader.qq.status;
		if (status === statusEnum.SUBMITTING) {
			this.setState(update(this.state, {
				submittedFile: { $set: { id, } }
			}));
		} else if (status === statusEnum.UPLOAD_SUCCESSFUL) {
			this.setState(update(this.state, {
				submittedFile: { $merge: { fromServer: true, status: uploadStatus.success } }
			}));
		}
	}

	renderComonStatusBlock(style, status, text) {
		return (
			<Row >
				<Col sm={4}>
					<Alert bsStyle={style}>
						<strong>{status}</strong> {text}
					</Alert>
				</Col>
			</Row>
		);
	}

	renderStatusBlock(status, error) {
		if (!status) {
			return null;
		}

		const statusText = status === uploadStatus.success ? 'Upload successful.' : 'Upload failed. Please reload the page and try again.';
		const statusStyle = status === uploadStatus.success ? 'success' : 'danger';
		return this.renderComonStatusBlock(statusStyle, statusText, error);
	}

	renderProgressBar(now, max) {
		return now != max &&
			<Row>
				<Col sm={4}>
					<ProgressBar
						active
						now={now}
						max={max} />
				</Col>
			</Row>;
	}

	renderFileDescr(input, image) {
		if (!input || !input.value) {
			return null;
		}

		let fileDescr;
		if (image) {
			fileDescr = <Image src={this.state.submittedFile.url} responsive />;
		} else {
			fileDescr = <h4><Label bsStyle="default">{this.state.submittedFile.filename}</Label></h4>;
		}

		return (
			<Row>
				<Col sm={4}>
					<p>{fileDescr}</p>
				</Col>
			</Row>
		);
	}

	clear() {
		this.setState(update(this.state, {
			submittedFile: { $set: {} }
		}));
	}

	render() {
		const { id, status, now, max, url, error } = this.state.submittedFile;
		const { uploader, image, input } = this.props;
		const statusBlock = status !== uploadStatus.success && this.renderStatusBlock(status, error);		// do not show 'success' message - might be misleading, users need to submit the form to finish the upload
		const progressBar = this.renderProgressBar(now, max);
		const fileDescription = this.renderFileDescr(input, image);
		return (
			<div>
				{fileDescription}
				{progressBar}
				{statusBlock}
			</div>
		);
	}

}

export default FileListener;